<template>
    <div
        :aria-labelledby="bannerId"
        class="grid items-center gap-x-2 rounded-lg border-2 p-3 text-content-primary"
        :class="`${variant}-banner`"
    >
        <DsIcon
            :icon="DS_ALERT_BANNER_VARIANT_ICONS[variant]"
            size="sm"
        />
        <h6
            :id="bannerId"
            class="text-content-md font-semibold"
        >
            {{ title }}
        </h6>
        <p
            v-if="$slots.default"
            class="desc mt-1 text-content-md"
            data-testid="alert-banner-description"
        >
            <slot />
        </p>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import { useId } from 'vue';
import { DS_ALERT_BANNER_VARIANT_ICONS, type DsAlertBannerVariant } from './alert-banner.type';

defineProps<{
    variant: DsAlertBannerVariant;
    title: string;
}>();

const bannerId = useId();
</script>

<style lang="scss" scoped>
.grid {
    grid-template-columns: min-content 1fr;
    grid-template-areas:
        'icon title'
        '.    desc';

    .desc {
        grid-area: desc;
    }
}

.warning-banner {
    @apply border-ds-yellow-400 bg-ds-yellow-200;
}

.error-banner {
    @apply border-ds-red-600 bg-ds-red-200;
}

.info-banner {
    @apply border-ds-blue-400 bg-ds-blue-200;
}
</style>
